// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__zSEP7","mainPageWrapper":"PageWrapper_mainPageWrapper__LMGjG"};